import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import Select, { createFilter } from 'react-select';
import { useCookies } from 'react-cookie';
import SimpleValue from 'react-select-simple-value';
import { Button, Col, Row } from 'react-bootstrap';
import { Link, navigate } from "raviger";
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCircleT, faCircleC, faCircleW
} from '@fortawesome/pro-solid-svg-icons';
import { loadUser } from "../accounts/AccountsUtils";
import { AuthContext } from "../accounts/AccountsReducer";
import { SystemErrorContext } from '../components/SystemError';

const customStyles = {
  // For the select it self, not the options of the select
  control: (styles) => {
    return {
      ...styles,
      color: '#FFF',
      cursor: 'default',
      backgroundColor: 'white',
      height: 50,
      minHeight: 50
    }
  },
  option: provided => ({
    ...provided,
    color: 'black'
  }),
};

function IncidentSelection() {

  const { dispatch, state } = useContext(AuthContext);
  const { setShowSystemError } = useContext(SystemErrorContext);

  const [incident, setIncident] = useState({id: '', slug: '', name: '', description: '', training:false, default_followup_days: 2, caltopo_map_id: '', watchduty_map_id: '', coordinates: []});
  const [options, setOptions] = useState([]);
  const [cookies, , removeCookie] = useCookies(['token']);

  const path = window.location.pathname;
  const org_slug = path.split('/')[1];

  // Custom filter option to provide a searchable string to filter on.
  const filterOption = (option, inputValue) => {
    const label = option.data.label;
    return label.toLowerCase().includes(inputValue.toLowerCase());
  };

  // Hook for initializing data.
  useEffect(() => {
    let unmounted = false;
    let source = axios.CancelToken.source();

    if (org_slug !== 'login') {

      const fetchIncidentData = async () => {
        // Fetch Incident data.
        await axios.get('/incident/api/incident/?organization_slug=' + org_slug, {
          cancelToken: source.token,
        })
        .then(response => {
          if (!unmounted) {
            let options = [];
            response.data.forEach(inc => {
              // Build incident option list.
              if (!inc.end_time || state.user.is_superuser || state.user.incident_perms) {
                options.push({
                  value: inc.id,
                  label: inc.name + ' (' + moment(inc.start_time).format('MM/DD/YYYY') + (inc.end_time ? ' - ' + moment(inc.end_time).format('MM/DD/YYYY') : '') + ')',
                  slug:inc.slug,
                  name:inc.name,
                  description:inc.description,
                  training:inc.training,
                  default_followup_days:inc.default_followup_days,
                  end_time:inc.end_time,
                  caltopo_map_id: inc.caltopo_map_id,
                  watchduty_map_id: inc.watchduty_map_id,
                  coordinates: [inc.latitude, inc.longitude]
                });
              }
            });
            setOptions(options);
          }
        })
        .catch(error => {
          if (!unmounted) {
            setShowSystemError(true);
          }
        });
      };
      fetchIncidentData();
    }

    // Reload user to get Org permission data
    loadUser({state, dispatch, path});

    // Cleanup.
    return () => {
      unmounted = true;
      source.cancel();
    };
  }, [state.user.is_superuser, state.user.incident_perms, org_slug]);

  return (
    <>
    <Row className='ms-auto me-auto mt-5 align-bottom'>
      <h1 style={{fontSize:"100px", textTransform: 'capitalize'}}>{state.organization.name}</h1>
    </Row>
    <Col xs={{ span:5 }} className="border rounded border-light shadow-sm ms-auto me-auto mb-auto ps-3 pe-3" style={{minWidth:"572px"}}>
      <SimpleValue options={options}>
        {simpleProps => <Select styles={customStyles} {...simpleProps} className="mt-3" placeholder="Select incident..." 
          onChange={(instance) => {
            dispatch({type: "SET_INCIDENT", data: {
              id:instance.value, 
              name:instance.name, 
              description:instance.description, 
              training:instance.training, 
              default_followup_days:instance.default_followup_days, 
              caltopo_map_id:instance.caltopo_map_id, 
              watchduty_map_id: instance.watchduty_map_id,
              coordinates: instance.coordinates
            }});
            navigate(window.location.pathname + "/" + instance.slug);
          }}
          getOptionLabel={(props) => {
            return (
              <div tw="flex items-center gap-2">
                {props.training ? <FontAwesomeIcon icon={faCircleT} className="me-1" /> : ""}
                {props.caltopo_map_id ? <FontAwesomeIcon icon={faCircleC} className="me-1" /> : ""}
                {props.watchduty_map_id ? <FontAwesomeIcon icon={faCircleW} className="me-1" /> : ""}
                <span>{props.label}</span>
              </div>
            );
          }}
          filterOption={filterOption}
        />}
      </SimpleValue>
      <Row>
        {state.user.is_superuser || state.user.incident_perms ? <Col>
          <Link href={'/' + org_slug + '/manage/incidents'} style={{textDecoration:"none"}}><Button size="lg" className="btn-primary mt-2 d-block w-100">Manage Incidents</Button></Link>
        </Col> : ""}
      </Row>
      <Row>
        {state.user.is_superuser || state.user.user_perms ? <Col>
          <Link href={`/${org_slug}/manage/organization`} style={{textDecoration:"none"}}><Button size="lg" className="btn-primary mt-2 d-block w-100">Manage Organization</Button></Link>
        </Col> : ""}
      </Row>
      <Link href={"/"} style={{textDecoration:"none"}}><Button size="lg" className="btn-primary mt-2 mb-3 d-block w-100">Return to Organizations</Button></Link>
    </Col>
    </>
  );
}

export default IncidentSelection;
